export default __webpack_public_path__ + "static/media/SalStack.js.90d347aa.SAVE";